import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Fields, Options } from '../../models/candidateprofile-genmodel';
// import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/dynamic-form.component';
import { HttpClient } from '@angular/common/http';

import { DatePipe } from '@angular/common';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DynamicCandidateProfileService } from '../../services/dynamic-candidate-profile.service';
import { FileDownloadService } from '../../services/file-download.service';

@Component({
  selector: 'app-dynamic-candidate-profile',
  templateUrl: './dynamic-candidate-profile.component.html',
  styleUrls: ['./dynamic-candidate-profile.component.scss'],
  standalone: false,
})
export class DynamicCandidateProfileComponent implements OnInit, OnChanges, OnDestroy {
  // @Output() countrycodevalue: EventEmitter<any> = new EventEmitter<any>();
  // @Output() countrycodevalue2: EventEmitter<any> = new EventEmitter<any>();
  // @Output() countrycodevalue3: EventEmitter<any> = new EventEmitter<any>();

  private destroy$ = new Subject<void>();
  private phoneValidationsSetup = false;
  
  field: Fields;
  group: UntypedFormGroup;
  phoneGroup: any;
  bgvChecked: string;

  codeControl = new UntypedFormControl('');
  codeControl2 = new UntypedFormControl('');
  codeControl3 = new UntypedFormControl('');
  countryCode = {
    name: 'country_code',
    displayName: 'Code',
    inputType: 'text',
    value: 91,
    validations: [
      {
        name: 'required',
        value: 'required',
        message: 'Required',
      },
      {
        name: 'pattern',
        value: '^[0-9]{1,5}$',
        message: 'Invalid',
      },
    ],
  };
  countryCode2 = {
    name: 'country_code2',
    displayName: 'Code',
    inputType: 'text',
    value: 91,
    validations: [
      {
        name: 'pattern',
        value: '^[0-9]{1,5}$',
        message: 'Invalid',
      },
    ],
  };
  countryCode3 = {
    name: 'country_code3',
    displayName: 'Code',
    inputType: 'text',
    value: 91,
    validations: [
      {
        name: 'pattern',
        value: '^[0-9]{1,5}$',
        message: 'Invalid',
      },
    ],
  };

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  chipCtrl = new UntypedFormControl();
  filteredChips = [];
  chips: any[] = [];
  selectedChip = [];
  chipList: any;
  keyword: any;
  startDate = new Date();
  instituteValue: any;

  @ViewChild('chipInput') chipInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  // @ViewChild(DynamicFormComponent, { static: false }) dynamicFormComponent: DynamicFormComponent;
  @Input() isEdit: boolean;
  @Input() genModel: Fields[] = [];
  @Input() candidateId: any;
  @Input() candidateDetails: any;
  @Input() saved: boolean;
  @Input() infyProfileEdit: boolean;
  // @Input() fields: Fields[] = [];
  // @Input() edit:boolean;
  // @Input() edu:EducationDetails[];
  @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();
  submitted: boolean;
  // @Input() group: FormGroup;
  form: UntypedFormGroup;
  date: Date;
  filteredOptions: any;
  url: any;
  name: string;
  options: any;

  data = {
    // Required
    type: 'dynamic candidate profile component', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '5', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };
  skills: any[];

  //image upload
  profileImgmessage: string;
  imagePath: any;
  imgURL: any;
  filename: any;
  fileMerge = [];
  lastindex: number;
  key: number;
  fileData: any;
  deletedFile = [];
  companyhiringtypeId = localStorage.getItem('fresherCompHiringTypeId');
  imgData: FormData;
  fileSizeError: string;
  fileAttachArray: any = [];
  fileMergeAttach: any[];
  attachmentData: any;
  blob: Blob;
  proof: boolean = false;
  align: boolean = true;
  addrProof: boolean = false;
  countryCode2Required: boolean;
  countryCode3Required: boolean;
  dispDocId: boolean = false;
  @Input() saveDocId: boolean;
  countryCodeValueChangesSetup: boolean = false;
  get value() {
    return this.form.value;
  }

  get validate() {
    this.form.markAllAsTouched();
    return this.form.valid;
  }

  constructor(
    private _telemetryServices: TelemetryServices,
    private dynamicCandidateService: DynamicCandidateProfileService,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<DynamicCandidateProfileComponent>,
    public dialog: MatDialog,
    private http: HttpClient,
    private datePipe: DatePipe,
    private fileDownloadService: FileDownloadService
  ) {
    this.chipCtrl.valueChanges.subscribe((data: string) =>
      // this._filter1(data, this.url)
      console.log(data, this.url),
    );
  }
  addAutoComplete(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const inputProfile = event.input;
      // Reset the input value
      if (inputProfile) {
        inputProfile.value = '';
      }
      this.chipCtrl.setValue(null);
    } else {
      const input2Profile = event.input;
      if (input2Profile) {
        input2Profile.value = '';
      }
    }
  }
  // add(event: MatChipInputEvent): void {
  //   // Add Chips only when MatAutocomplete is not open
  //   // To make sure this does not conflict with OptionSelected Event
  //   if (!this.matAutocomplete.isOpen) {
  //     const input = event.input;
  //     const value = event.value;
  //     console.log(this.filteredChips);

  //     if (this.filteredChips) {
  //       const data = this.filteredChips.find(x => x.value == value);
  //       console.log(data);

  //       // Add our Chip
  //       if (data) {
  //         if ((value || '').trim()) {
  //           this.chips.push(data);
  //         }
  //       }

  //       // Reset the input value
  //       if (input) {
  //         input.value = '';
  //       }
  //     }
  //     this.chipCtrl.setValue(null);
  //   }
  // }

  remove(chip: Options): void {
    const index = this.chips.indexOf(chip);

    if (index >= 0) {
      this.chips.splice(index, 1);
      this.selectedChip.splice(index, 1);
    }
    this.form.get(this.name).setValue(this.selectedChip);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedVal = this.filteredChips.find((res) => res.value === event.option.value);
    console.log(selectedVal);
    const model = this.genModel.filter((field) => field.type === 16);
    model.forEach((field) => {
      console.log(field.name);
      this.name = field.name;
    });
    let flag: boolean = true;
    if (this.selectedChip.length > 0) {
      for (const ckey of this.selectedChip) {
        if (ckey.key == selectedVal.key) {
          flag = false;
          break;
        }
      }
      if (flag) {
        this.selectedChip.push(selectedVal);
        this.form.get(this.name).setValue(this.selectedChip);
        this.chips.push(event.option);
        this.chipInput.nativeElement.value = '';
        this.chipCtrl.setValue(null);
      } else {
        this.chipInput.nativeElement.value = '';
        this.chipCtrl.setValue(null);
      }
    } else {
      this.selectedChip.push(selectedVal);
      console.log(this.form.get(this.name));
      this.form.get(this.name).setValue(this.selectedChip);
      this.chips.push(event.option);
      this.chipInput.nativeElement.value = '';
      this.chipCtrl.setValue(null);
    }
  }

  // private _filter1(value, url) {
  //   if (value !== null && value !== "") {
  //     const filterValue = value.toLowerCase();
  //     this.filteredChips = this.options.filter(option => option.value.toLowerCase().includes(filterValue));
  //   }
  //   else {
  //     this.filteredChips = [];
  //   }
  // }
  getFilterData(url, value) {
    return this.http.get<Options[]>(url + value);
  }

  //  openDialog(genModel): void {
  //   const dialogRef = this.dialog.open(DynamicCandidateProfileComponent, {
  //     width: '250px',
  //   data: this.genModel
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //     // this.animal = result;
  //   });
  // }
  onClick(_genmodel) {
    let dialogRef;
    dialogRef.afterClosed().subscribe((_result) => {
      console.log('the dialog closed');
    });
    // dialogRef.close();
  }

  getDate(value) {
    if (value != null && value !== '') {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return this.datePipe.transform(date, 'dd-MMM-yyyy');
      }
    }
    return null;
  }
  ngOnInit() {
    this.dispDocId = false;
    console.log(this.dynamicCandidateService.getBool(), 'inside oninit');
    if (this.dynamicCandidateService.getBool()) {
      this.proof = true;
      this.dispDocId = true;
    }

    this.data.subtype = 'dynamic candidate profile';
    this.data.itype = 'view profile component';
    this.data.stageto = 'view profile component loading';
    // if (this.data) {
    //   this._telemetryServices.telemetryImpression(this.data);
    // }
    // console.log(this.fields);
    console.log(this.genModel);
    if (this.genModel) {
      this.form = this.createControl();

      const checkboxArray = this.genModel.filter((res) => res.type === 5);
      if (checkboxArray && checkboxArray.length > 0) {
        checkboxArray.forEach((val) => {
          if (this.form) {
            if (val.name == 'highestDegree' || val.name == 'tillDate') {
              if (val.value && val.value == 'Y') {
                this.form.get(val.name).setValue(true);
              } else {
                this.form.get(val.name).setValue(false);
              }
            }
          }
        });
      }
      const radioArray = this.genModel.filter((res) => res.type === 12);
      if (radioArray && radioArray.length > 0) {
        radioArray.forEach((val) => {
          if (this.form) {
            if (val.name === 'bgVerification') {
              if (val.value && val.value === 'Y') {
                this.form.get(val.name).setValue('Y');
              } else if (val.value && val.value === 'N') {
                this.form.get(val.name).setValue('N');
              } else {
                this.form.get(val.name).setValue(null);
              }
            }
          }
        });
      }
      const datearray = this.genModel.filter((res) => res.type === 15);
      if (datearray && datearray.length > 0) {
        datearray.forEach((date) => {
          if (date.value) {
            date.value = this.datePipe.transform(new Date(date.value), 'yyyy-MM-dd');
          }
        });
      }
      const selectArray = this.genModel.filter((res) => res.type === 11);
      if (selectArray && selectArray.length > 0) {
        selectArray.forEach((val) => {
          if (this.form) {
            if (val.name == 'addressProofType') {
              this.addrProof = true;
            }
            if (val.name == 'attachmentType') {
              if (this.form.get('addressProofType') !== null) {
                if (val.value == 'address_proof') {
                  this.proof = true;
                } else {
                  this.proof = false;
                  this.align = false;
                }
              }
              if (
                val.value == 'Proof of Philhealth' ||
                val.value == 'Proof of SSS' ||
                val.value == 'Proof of PAGIBIG' ||
                val.value == 'Proof of Tax Identification Number'
              ) {
                this.dispDocId = true;
                this.addrProof = true;
              } else {
                this.dispDocId = false;
                this.align = false;
                this.addrProof = true;
              }
              if (val.value) {
                this.form.get('attachmentType').disable();
                if (this.form.get('addressProofType') !== null) {
                  this.form.get('addressProofType').disable();
                }
                if (this.form.get('documentId') !== null) {
                  this.form.get('documentId').disable();
                }
              } else {
                this.http.get<any>(val.url + this.companyhiringtypeId).subscribe((res) => {
                  if (res) {
                    const temp = [];
                    res.forEach((res, _key) => {
                      temp.push({ key: res['attachmentId'], value: res['attachmentType'] });
                    });
                    val.options = <Options[]>temp;
                  }
                });
              }
            } else {
              if (val.options && val.options.length > 0) {
                val.options.forEach((ele) => {
                  if (ele.selected) {
                    this.form.get(val.name).setValue(ele.value);
                  }
                });
              }
              if (val.name == 'addressType' && val.value) {
                this.form.get(val.name).disable();
              }
            }
          }
        });
      }
      const autoCompletearray = this.genModel.filter((res) => res.type === 10);
      if (autoCompletearray && autoCompletearray.length > 0) {
        console.log(autoCompletearray);
        autoCompletearray.forEach((val) => {
          if (val.url) {
            if (val.name == 'city') {
              if (val.value) {
                val.options.forEach((ele) => {
                  if (ele.selected) {
                    this.form.get('city')['cityId'] = ele.key;
                  }
                });
              }
              // this.http.get<any>(val.url + val.value).subscribe(res => {
              //   let temp = [];
              //   res.forEach((res, _key) => {
              //     temp.push({ key: res['city_id'], value: res['city_state_country'] });
              //   })
              //   this.form.get('city').setValue(val.value);
              // })
            } else if (val.name == 'universityName') {
              // this.http.get<any>(val.url).subscribe(res => {
              //   if (res) {
              //     let temp = [];
              //     res.forEach((res, _key) => {
              //       temp.push({ key: res['univeristyCode'], value: res['universityName'] });
              //     })
              //     val.options = <Options[]>temp;
              //   }
              // })
            } else if (val.name == 'institute') {
              // this.http.get<any>(val.url).subscribe(res => {
              //   if (res) {
              //     let temp = [];
              //     res.forEach((res, _key) => {
              //       temp.push({ key: res['instituteId'], value: res['instituteName'] });
              //     })
              //     val.options = <Options[]>temp;
              //   }
              // })
            } else {
              this.http.get<any>(val.url + val.value).subscribe((res) => {
                this.form.get(val.name).patchValue(res[0].value);
              });
            }

            this.form.get(val.name).valueChanges.subscribe((value) => {
              const cityValue = value ? value.trim() : null;
              if (val.url) {
                this.filteredOptions = [];
                if (val.name == 'city') {
                  if (cityValue && cityValue.length > 0) {
                    this.http.get<any[]>(val.url + cityValue).subscribe((res) => {
                      const temp = [];
                      res.forEach((res, _key) => {
                        temp.push({ key: res['city_id'], value: res['city_state_country'] });
                      });
                      this._filter(value, temp, val.name);
                    });
                  }
                } else if (val.name == 'universityName') {
                  this._filter(value, val.options, val.name);
                } else if (val.name == 'institute') {
                  if (value && value.length > 2) {
                    if (
                      this.form.get('candidateEducationType').value == 'XII/SSC/High/Equivalent' ||
                      this.form.get('candidateEducationType').value == 'X/SSLC/Junior/Equivalent' ||
                      this.form.get('candidateEducationType').value == 'Diploma'
                    ) {
                    } else {
                      // this._filter(value, val.options, val.name)
                      if (
                        this.instituteValue &&
                        this.instituteValue.toLowerCase() == value.substring(0, 3).toLowerCase()
                      ) {
                        this._filter(value, val.options, val.name);
                      } else {
                        let searchString = value;
                        if (value.length > 3) {
                          searchString = value.substring(0, 3);
                        }
                        this.instituteValue = searchString;
                        this.http.get<any[]>(val.url + searchString).subscribe((res) => {
                          const temp = [];
                          res.forEach((res, _key) => {
                            temp.push({ key: res['instituteId'], value: res['instituteName'] });
                          });
                          val.options = temp;
                          this._filter(value, temp, val.name);
                        });
                      }
                    }
                  }
                } else {
                  this.http.get<any[]>(val.url + value).subscribe((res) => {
                    this._filter(value, res, val.name);
                  });
                }
              }
            });
          } else {
            console.log('in else');
            if (val.name != 'city') {
              if (val.name == 'state' || val.name == 'country') {
                this.form.get(val.name).disable();
              } else {
                val.options.forEach((ele) => {
                  if (ele.selected) {
                    console.log(val.name, ele.value);
                    if (val.name === 'currentEmployer') {
                      this.genModel.find((fieldRes) => fieldRes.name === 'currentEmployer').value = ele.value;
                    }

                    this.form.get(val.name).patchValue(ele.value);
                    // console.log(autoCompletearray);
                  }
                });

                this.form.get(val.name).valueChanges.subscribe((value) => {
                  console.log(value);
                  this._filter(value, val.options, val.name);
                });
              }
            }
          }
        });
      }
      const model = this.genModel.filter((field) => field.type === 16);
      console.log(model);
      if (model && model.length > 0) {
        model.forEach((res) => {
          this.name = res.name;
          if (res.url) {
            this.url = res.url;
            // this.http.get(res.url).subscribe(val => {
            //   this.chipList = val;
            //   console.log(this.chipList);
            //   this.form.get(res.name).patchValue(val[0].value);
            //   this.name = res.name;
            //   this.options = this.chipList;
            // })
            if (res.options.length > 0) {
              this.chips = [];
              res.options.forEach((element) => {
                if (element.selected) {
                  this.chips.push(element);
                }
              });
              res.options.forEach((element) => {
                if (element.selected) {
                  this.selectedChip.push(element);
                }
              });
              // this.selectedChip = this.chips;
              this.form.get(res.name).setValue(this.chips);
            }
          }
        });
      }

      const imgModel = this.genModel.filter((field) => field.type === 13);
      console.log(imgModel);
      if (imgModel && imgModel.length > 0) {
        imgModel.forEach((res) => {
          // this.imgURL = "assets/images/avatar2.png";
          this.dynamicCandidateService.getImageData(this.form.get('candidateId').value, 'CD', 2).subscribe((imgRes) => {
            console.log(imgRes, '123456', '{"ids":{"5eece11c96ea1d00013cdbe3":"image.jpg"},"statusMessage":"success"}');

            if (imgRes.id) {
              this.dynamicCandidateService.getImage(imgRes.id).subscribe(async (fileRes) => {
                const returnBase64 = true;
                const base64 = await this.fileDownloadService.decodeFileBytes(fileRes.file, returnBase64) //fileRes.file.data;
                this.imgURL = 'data:image/' + fileRes.fileType.substr(1) + ';base64,' + base64;
                // this.imgURL = null;
              });
            }
          });
          if (res.url) {
          }
        });
      }

      const attachModel = this.genModel.filter((field) => field.type === 33);
      if (attachModel && attachModel.length > 0) {
        attachModel.forEach((_val) => {
          if (this.form) {
            // if (val.name == 'attachmentBrowse') {
            //   this.http.get<any>(val.value).subscribe(res => {
            //     if (res) {
            //       this.attachmentData = res;
            //       this.form.get('attachmentBrowse')['fileName'] = res.fileName;
            //       this.form.get('attachmentBrowse')['fileId'] = res.fileId;
            //     }
            //   })
            // }
          }
        });
      }

      // this.fileService.getFileIds(data.candidateBasicDetail.candidateId, "CD", 2).subscribe(res => {
      //   if (res && res.id) {
      //     this.fileService.downloadFile(res.id).subscribe(fileRes => {
      //       console.log(fileRes);
      //       const base64 = fileRes.file.data;
      //       this.imgURL = 'data:image/' + fileRes.fileType.substr(1) + ';base64,' + base64;
      //       this.registerForm.get('photo').clearValidators();
      //       this.registerForm.get('photo').updateValueAndValidity();
      //     })
      //   }
      // })

      console.log(this.url);

      console.log(this.form);
      console.log(this.isEdit);
    }

    if (this.genModel.find((res) => res.name == 'primaryContactNo')) {
      this.codeControl.setValidators(this.bindValidations1(this.countryCode.validations));
      this.form.addControl('country_code', this.codeControl);
      this.codeControl2.setValidators(this.bindValidations1(this.countryCode2.validations));
      this.form.addControl('country_code2', this.codeControl2);
      this.codeControl3.setValidators(this.bindValidations1(this.countryCode3.validations));
      this.form.addControl('country_code3', this.codeControl3);
    }
  }
  bindValidations1(validationList) {
    if (validationList && validationList.length > 0) {
      const validList = [];
      validationList.forEach((valid) => {
        switch (valid.name) {
          case 'required': {
            validList.push(Validators.required);
            break;
          }
          case 'pattern': {
            validList.push(Validators.pattern(valid.value));
            break;
          }
        }
      });
      return Validators.compose(validList);
    }
    // if (validationList && validationList.length > 0) {
    //   const validList = [];
    //   validationList.forEach((valid) => {
    //     switch (valid.name) {
    //       case 'required': {
    //         validList.push(Validators.required);
    //         break;
    //       }
    //       case 'pattern': {
    //         validList.push(Validators.pattern(valid.value));
    //         break;
    //       }
    //     }
    //   });
    //   return Validators.compose(validList);
    // }
    // if (validationList && validationList.length > 0) {
    //   const validList = [];
    //   validationList.forEach((valid) => {
    //     switch (valid.name) {
    //       case 'required': {
    //         validList.push(Validators.required);
    //         break;
    //       }
    //       case 'pattern': {
    //         validList.push(Validators.pattern(valid.value));
    //         break;
    //       }
    //     }
    //   });
    //   return Validators.compose(validList);
    // }
  }
  onTypegetSkill(val) {
    const skillKeyword = val;
    if (skillKeyword !== undefined && skillKeyword != null && typeof skillKeyword === 'string' && skillKeyword !== '') {
      this.skills = [];

      this.http.get<any[]>(this.url + val).subscribe((data1) => {
        console.log(data1);
        this.filteredChips = [];
        const temp = [];
        data1.forEach((res, _key) => {
          temp.push({ key: res['skill_id'], value: res['skill_name'] });
        });
        this.filteredChips = temp;
        // data1.forEach(response => {
        //   this.filteredChips.push(response)
        // })
      });
    }
  }

  // Displayform(){
  //       console.log(this.dynamicFormComponent.value);

  //     }

  ngOnChanges(changes: SimpleChanges) {
    this.dispDocId = true;
    console.log(this.dynamicCandidateService.getBool(), 'inside onchanges');

    if (this.dynamicCandidateService.getBool()) {
      this.proof = true;
    }

    console.log(changes);
    if (changes['isEdit']) {
      const selectArray1 = this.genModel.filter((res) => res.type === 25);
      if (selectArray1 && selectArray1.length > 0) {
        selectArray1.forEach((val) => {
          if (this.form) {
            if (this.form.get(val.name).value) {
              const number = this.form.get(val.name).value;
              if (val.name == 'primaryContactNo') {
                if (String(number).includes('+')) {
                  this.countryCode.value = number.split('+').pop().split('-')[0];
                  const primaryno = number.split('-').pop();
                  this.form.get(val.name).setValue(primaryno);
                  this.form.get('country_code').setValue(this.countryCode.value);
                  //  console.log("primary no---",primaryno,"form--",this.form.get('primaryContactNo').setValue(primaryno),this.form.get('primaryContactNo').value);
                  console.log('country code---', this.countryCode.value);
                  // this.countrycodevalue.emit(this.countryCode.value);
                } else {
                  this.countryCode.value = null;
                  const primaryno = number.split('-').pop();
                  this.form.get(val.name).setValue(primaryno);
                  this.form.get('country_code').setValue(this.countryCode.value);
                  //  console.log("primary no---",primaryno,"form--",this.form.get('primaryContactNo').setValue(primaryno),this.form.get('primaryContactNo').value);
                  console.log('country code---', this.countryCode.value);
                  // this.countrycodevalue.emit(this.countryCode.value);
                }
                this.setPhoneValidations(this.form.get('country_code').value, 'country_code', 'primaryContactNo');
              } else if (val.name == 'alternateContactNo') {
                if (String(number).includes('+')) {
                  this.countryCode2.value = number.split('+').pop().split('-')[0];
                  const primaryno = number.split('-').pop();
                  this.form.get(val.name).setValue(primaryno);
                  this.form.get('country_code2').setValue(this.countryCode2.value);
                  //  console.log("primary no---",primaryno,"form--",this.form.get('primaryContactNo').setValue(primaryno),this.form.get('primaryContactNo').value);
                  console.log('country code2---', this.countryCode2.value);
                  // this.countrycodevalue2.emit(this.countryCode2.value);
                } else {
                  this.countryCode2.value = null;
                  const primaryno = number.split('-').pop();
                  this.form.get(val.name).setValue(primaryno);
                  this.form.get('country_code2').setValue(this.countryCode2.value);
                  //  console.log("primary no---",primaryno,"form--",this.form.get('primaryContactNo').setValue(primaryno),this.form.get('primaryContactNo').value);
                  console.log('country code---', this.countryCode2.value);
                  // this.countrycodevalue2.emit(this.countryCode2.value);
                }
                this.setPhoneValidations(this.form.get('country_code2').value, 'country_code2', 'alternateContactNo');
              } else if (val.name == 'emergencyContactNo') {
                if (String(number).includes('+')) {
                  this.countryCode3.value = number.split('+').pop().split('-')[0];
                  const primaryno = number.split('-').pop();
                  this.form.get(val.name).setValue(primaryno);
                  this.form.get('country_code3').setValue(this.countryCode3.value);
                  //  console.log("primary no---",primaryno,"form--",this.form.get('primaryContactNo').setValue(primaryno),this.form.get('primaryContactNo').value);
                  console.log('country code3---', this.countryCode3.value);
                  // this.countrycodevalue3.emit(this.countryCode3.value);
                } else {
                  this.countryCode3.value = null;
                  const primaryno = number.split('-').pop();
                  this.form.get(val.name).setValue(primaryno);
                  this.form.get('country_code3').setValue(this.countryCode3.value);
                  //  console.log("primary no---",primaryno,"form--",this.form.get('primaryContactNo').setValue(primaryno),this.form.get('primaryContactNo').value);
                  console.log('country code3---', this.countryCode3.value);
                  // this.countrycodevalue3.emit(this.countryCode3.value);
                }
                this.setPhoneValidations(this.form.get('country_code3').value, 'country_code3', 'emergencyContactNo');
              }
            }
          }
        });
        if (this.form && !this.countryCodeValueChangesSetup) {
          this.countryCodeValueChangesSetup = true;
          this.form.get('country_code').valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
              this.setPhoneValidations(value, 'country_code', 'primaryContactNo');
            });
          this.form.get('country_code2').valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
              this.setPhoneValidations(value, 'country_code2', 'alternateContactNo');
            });
          this.form.get('country_code3').valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
              this.setPhoneValidations(value, 'country_code3', 'emergencyContactNo');
            });
        }
        } 
      const datearray = this.genModel.filter((res) => res.type === 15);
      if (datearray && datearray.length > 0) {
        datearray.forEach((date) => {
          if (date.value) {
            date.value = this.datePipe.transform(new Date(date.value), 'yyyy-MM-dd');
          }
        });
      }
      if (changes['isEdit'].previousValue != changes['isEdit'].currentValue) {
        // console.log(this.edit);
        if (this.genModel) {
          const checkboxArray = this.genModel.filter((res) => res.type === 5);
          if (checkboxArray && checkboxArray.length > 0) {
            checkboxArray.forEach((val) => {
              if (this.form) {
                if (val.name == 'highestDegree') {
                  if (val.value && val.value == 'Y') {
                    this.form.get(val.name).setValue(true);
                  } else {
                    this.form.get(val.name).setValue(false);
                  }
                }
              }
            });
          }

          const selectArray = this.genModel.filter((res) => res.type === 11);
          // console.log("onchanges", selectArray);

          if (selectArray && selectArray.length > 0) {
            selectArray.forEach((val) => {
              if (this.form) {
                if (val.name == 'attachmentType') {
                  if (val.value == 'address_proof') {
                    this.proof = true;
                  } else {
                    this.proof = false;
                    this.align = false;
                  }
                  if (
                    val.value === 'address_proof' ||
                    val.value === 'Proof of Philhealth' ||
                    val.value === 'Proof of SSS' ||
                    val.value === 'Proof of PAGIBIG' ||
                    val.value === 'Proof of Tax Identification Number'
                  ) {
                    this.dispDocId = true;
                    this.addrProof = true;
                  } else {
                    this.dispDocId = false;
                    this.align = false;
                    this.addrProof = true;
                  }
                  if (val.value == null) {
                    this.http.get<any>(val.url + this.companyhiringtypeId).subscribe((res) => {
                      if (res) {
                        const temp = [];
                        res.forEach((res, _key) => {
                          temp.push({ key: res['attachmentId'], value: res['attachmentType'] });
                        });
                        val.options = <Options[]>temp;
                      }
                    });
                  }
                } else {
                  if (val.options && val.options.length > 0) {
                    val.options.forEach((ele) => {
                      if (ele.selected) {
                        this.form.get(val.name).setValue(ele.value);
                      }
                    });
                  }
                  if (val.name == 'addressType' && val.value) {
                    this.form.get(val.name).disable();
                  }
                }
              }
            });
          }
          const autoCompletearray = this.genModel.filter((res) => res.type === 10);

          if (autoCompletearray && autoCompletearray.length > 0) {
            autoCompletearray.forEach((val) => {
              if (this.form) {
                this.form.get(val.name).valueChanges.subscribe((value) => {
                  if (value.length == 0) {
                    // this.form.get(val.name).setErrors({ 'required': true })
                  }
                  if (val.options) {
                    if (val.name != 'city' && val.name != 'institute' && val.name != 'universityName') {
                      this._filter(value, val.options, val.name);
                    }
                  }
                  // if (value.length >= 1) {
                  //   this.filteredOptions = ['test'];
                  //   // if (this.field.name === "digitalOffering") {
                  //   //   this.group.get('digitalTag').setValue('');
                  //   // }
                  // }
                  // else { this.filteredOptions = [] }
                });
              }
            });
          }

          console.log(this.form);
          console.log(this.isEdit);
        }
      }

      if (this.infyProfileEdit) {
        this.form.get('country_code')?.disable();
        this.form.get('country_code2')?.disable();
        this.form.get('country_code3')?.disable();

        this.genModel.forEach((field) => {
          if (field.name != 'employeeNo') {
            this.form.get(field.name)?.disable();
          }
        });
      }
    }
    const datearray = this.genModel.filter((res) => res.type === 15);
    if (datearray && datearray.length > 0) {
      datearray.forEach((date) => {
        if (date.value) {
          date.value = this.datePipe.transform(new Date(date.value), 'yyyy-MM-dd');
        }
      });
    }
  }

  onSubmit() {
    // event.preventDefault();
    // event.stopPropagation();
    console.log(this.form.value);
    // if (this.form.valid) {
    //   this.submit.emit(this.form.value);
    // } else {
    //   this.validateAllFormFields(this.form);
    // }
    // this.submitted = true;
  }

  createControl() {
    const group = this.fb.group({});
    // console.log(this.fields)
    console.log(this.genModel);
    this.genModel.sort((a, b) => a.order - b.order);
    this.genModel.forEach((field) => {
      if (field.type === 20) {
        return;
      }
      const control = this.fb.control(field.value, this.bindValidations(field.validations || []));

      group.addControl(field.name, control);
      // if (field.type === 10) {
      //   if (field.url) {
      //     // this.http.get(field.url + this.candidateId).subscribe(res => {
      //     //   console.log(res);

      //     //   if (res) {
      //     //     field.options = <Options[]>res;
      //     //     this.filteredOptions = res;

      //     //   } else { field.options = []; this.filteredOptions = []; }
      //     // });
      //   } else {
      //     // field.options = [];
      //   }
      // }
    });
    // console.log(group);
    return group;
  }

  private _filter(value: string, options: Options[], fieldName: string) {
    this.filteredOptions = [];
    const result = [];
    if (value && value.length > 0) {
      if (fieldName == 'universityName' || fieldName == 'degree') {
        if (value.length > 3) {
          const filterValue = value.toLowerCase();
          options.forEach((ele) => {
            if (ele.value != null && ele.value.toLowerCase().includes(filterValue)) {
              this.filteredOptions.push(ele);
              result.push(ele);
            }
          });
        } else {
          const filterValue = value.toLowerCase();
          options.forEach((ele) => {
            if (ele.value != null && ele.value.toLowerCase().startsWith(filterValue)) {
              this.filteredOptions.push(ele);
              result.push(ele);
            }
          });
        }
      } else if (fieldName == 'institute') {
        if (value.length > 3) {
          const filterValue = value.toLowerCase();
          options.forEach((ele) => {
            if (
              ele.value != null &&
              this.filteredOptions.length < 101 &&
              ele.value.toLowerCase().includes(filterValue)
            ) {
              this.filteredOptions.push(ele);
              result.push(ele);
            }
          });
        } else {
          const filterValue = value.toLowerCase();
          options.forEach((ele) => {
            if (
              ele.value != null &&
              this.filteredOptions.length < 101 &&
              ele.value.toLowerCase().startsWith(filterValue)
            ) {
              this.filteredOptions.push(ele);
              result.push(ele);
            }
          });
        }
      } else {
        const filterValue = value.toLowerCase();
        // console.log(options.filter(option => option.value.toLowerCase().includes(filterValue)));
        // let tempOptions = options.filter(temp => temp.value != null)
        // this.filteredOptions = tempOptions.filter(option => option.value.toLowerCase().includes(filterValue))
        options.forEach((ele) => {
          if (ele.value != null && ele.value.toLowerCase().includes(filterValue)) {
            this.filteredOptions.push(ele);
            result.push(ele);
          }
        });
      }
    }
    return result;
  }
  onchange(key, value?, fieldName?) {
    if (fieldName == 'city') {
      const temp = value.split(',');
      console.log(temp);
      this.form.get('city')['cityId'] = key;
      this.form.get('city').setValue(temp[0]);
      this.form.get('state').setValue(temp[1]);
      this.form.get('country').setValue(temp[2]);
    }
    if (fieldName == 'attachmentType') {
      this.form.get('attachmentType')['attachmentId'] = key;
    }
    if (fieldName == 'institute') {
      console.log(key, value, fieldName);
      this.form.get('institute')['instituteId'] = key;
    }
  }
  // bindValidations(validations: any) {
  //   console.log("logged inside");

  //   if (validations.length > 0) {
  //     const validList = [];
  //     validations.forEach(valid => {
  //       validList.push(valid.validator);
  //     });
  //     console.log(validList);
  //     return Validators.compose(validList);
  //   }
  //   return null;
  // }
  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach((valid) => {
        switch (valid.name) {
          case 'required': {
            validList.push(Validators.required);
            break;
          }
          case 'pattern': {
            validList.push(Validators.pattern(valid.value));
            break;
          }
          case 'maxlength': {
            validList.push(Validators.maxLength(valid.value));
            break;
          }
          case 'minlength': {
            validList.push(Validators.minLength(valid.value));
            break;
          }
          case 'max': {
            validList.push(Validators.max(valid.value));
            break;
          }
        }
      });
      return Validators.compose(validList);
    }
    return null;
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  changeSelect(updatedValue, field) {
    if (field.name == 'candidateEducationType') {
      this.form.get('institute').setValue(null);
    }
    this.form.get(field.name).setValue(updatedValue.value);
    if (field.value == 'address_proof' && field.name == 'attachmentType') {
      this.proof = true;
    }
    if (field.value !== 'address_proof' && field.name == 'attachmentType') {
      this.proof = false;
    }

    if (field.name == 'attachmentType') {
      const Arr = ['Proof of Philhealth', 'Proof of SSS', 'Proof of PAGIBIG', 'Proof of Tax Identification Number'];
      if (Arr.includes(field.value)) {
        console.log('Working');
        this.dispDocId = true;
      } else {
        this.dispDocId = false;
      }
      console.log('Hi', this.dispDocId);
    }
  }
  omit_special_char(event, fieldName?) {
    const k = event.charCode; //         k = event.keyCode;  (Both can be used)
    if (fieldName == 'houseNo' || fieldName == 'area') {
      if (k == 44 || k == 45 || k == 47 || k == 46) {
        return true;
      } else {
        return (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57);
      }
    } else if (
      fieldName == 'currentAnnualGrossCompensation' ||
      fieldName == 'fixedSalary' ||
      fieldName == 'variablePay' ||
      fieldName == 'revisedAnnualGrossCompensation' ||
      fieldName == 'expectedAnnualGrossCompensation' ||
      fieldName == 'otherBenefits' ||
      fieldName == 'percentage' ||
      fieldName == 'lastName'
    ) {
      if (k == 46) {
        return true;
      } else {
        return (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57);
      }
    } else {
      return (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57);
    }
  }
  ngOnDestroy() {
    // telemtry end call

    this.data.subtype = 'dynamic candidate profile cleanup stage/end of page';
    this.data.itype = 'AUTO';
    this.data.stageto = 'destroy component,initial page';
    if (this.data) {
      // this._telemetryServices.telemetryEnd(this.data);
    }
    
    // Unsubscribe from all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }

  //image upload code
  preview(files) {
    if (files.length === 0) {
      return;
    }

    // var mimeType = files[0].type;
    const mimeType = files[0].name.split('.').pop().toLowerCase();
    console.log(mimeType);
    if (files[0].size > 2097152 && (mimeType == 'png' || mimeType == 'jpg' || mimeType == 'jpeg')) {
      this.profileImgmessage = 'Please upload maximum 2MB size only.';
      return;
    } else if (mimeType == 'png' || mimeType == 'jpg' || mimeType == 'jpeg') {
      this.profileImgmessage = null;
    } else {
      this.profileImgmessage = 'Please upload the correct format png|jpg|jpeg';
      return;
    }

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      console.log(this.imgURL);
      if (this.imgURL) {
        this.form.get('photograph').clearValidators();
      }
    };
    this.onFileSelected(files);
  }

  //Multi Chunks
  onFileSelected(filesArray) {
    const files = filesArray;
    this.filename = [];
    this.fileMerge = [];
    const lastChunksize = 0;
    const chunkSize = 524288; //maximum 512 = 524,288, 256 = 262,144 B
    this.lastindex = files.length;
    this.key = 1;

    // for (let file of files) {
    this.filename.push(files[0].name);
    this.readFile(files[0], lastChunksize, this.myCallback.bind(this), chunkSize);
    // }
    this.fileData = this.fileMerge;
  }

  myCallback(file, lastChunksize, result, chunkSize) {
    lastChunksize = lastChunksize + chunkSize;
    if (result) {
      this.readFile(file, lastChunksize, this.myCallback.bind(this), chunkSize);
    } else {
      console.log('here end of rec');
      this.saveAttachment(this.form.get('candidateId').value, this.companyhiringtypeId);
      ///end recursion
    }
  }

  readFile(file, lastChunksize: number, callback, chunkSize) {
    const fileBlob = file.slice(lastChunksize, lastChunksize + chunkSize);
    if (fileBlob.size != 0) {
      const fileReader = new FileReader();
      fileReader.onloadend = (_result) => {
        this.fileMerge.push(file);
        this.fileData = this.fileMerge;
        return callback(file, lastChunksize, fileReader.result, chunkSize);
      };
      fileReader.readAsText(fileBlob);
    } else {
      return callback(file, lastChunksize, false);
    }
  }

  saveAttachment(genericId, companyHiringTypeId) {
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.dynamicCandidateService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {},
        );
      });
    }

    const fd = new FormData();
    fd.append('objectId', genericId);
    fd.append('objectType', 'CD');
    fd.append('companyHiringTypeId', companyHiringTypeId);
    fd.append('attachmentId', '2');
    if (this.fileMerge && this.fileMerge.length > 0) {
      this.fileMerge.forEach((file) => {
        fd.append('file[' + file.name + ']', file);
      });
      this.imgData = fd;
      console.log(fd, this.fileMerge.length, this.fileMerge);
      this.dynamicCandidateService.uploadImageData(fd).subscribe((data) => {
        console.log(data);
      });

      // this.fileService.upload(fd).subscribe(res => {
      //   if (res.type === 4) {
      //     console.log('here');
      //     // this.apply(Object.keys(res.body.ids));
      //   }
      // }, err => {
      //   console.log(err);

      // })
    }
  }
  // image upload code end

  setValueInTooltip(skillName: string) {
    return skillName;
  }

  dateSet(fieldName) {
    if (fieldName == 'dateOfJoining') {
      this.form.get('dateOfLeaving').setValue(null);
    } else if (fieldName == 'from_date') {
      this.form.get('to_date').setValue(null);
    }
  }

  checkDate(fieldName, minMax) {
    if ((fieldName == 'dateOfJoining' || fieldName == 'from_date') && (minMax == 'min' || minMax == 'max')) {
      if (fieldName == 'from_date' && minMax == 'max') {
        return new Date();
      }
      if (fieldName == 'dateOfJoining' && minMax == 'max') {
        return new Date();
      }
      return '';
    } else if (fieldName == 'dateOfLeaving') {
      if (minMax == 'min') {
        return new Date(this.form.get('dateOfJoining').value);
      } else if (minMax == 'max') {
        return new Date();
      } else {
        return '';
      }
    } else if (fieldName == 'to_date') {
      if (minMax == 'min') {
        return new Date(this.form.get('from_date').value);
      } else {
        return new Date();
      }
    } else if (fieldName == 'dateOfBirth') {
      if (minMax == 'max') {
        const currDate = new Date();
        return new Date(currDate.setFullYear(currDate.getFullYear() - 18));
      } else if (minMax == 'min') {
        const currDate = new Date();
        return new Date(currDate.setFullYear(currDate.getFullYear() - 60));
      } else {
        return '';
      }
    } else if (fieldName == 'monthAndYear') {
      if (minMax == 'min') {
        return new Date();
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  reserFilterOptions(event) {
    if (!event.relatedTarget) {
      return null;
    }
    this.filteredOptions = [];
  }

  displayDate(fieldName) {
    if (fieldName == 'dateOfLeaving') {
      if (
        this.form.get('tillDate').value &&
        (this.form.get('tillDate').value == 'Y' || this.form.get('tillDate').value == true)
      ) {
        this.form.get('dateOfLeaving').disable();
        this.form.get('dateOfLeaving').setValue(null);
        return true;
      } else {
        this.form.get('dateOfLeaving').enable();
        return true;
      }
    } else {
      return true;
    }
  }

  checkboxChange(event, fieldName) {
    if (fieldName == 'tillDate') {
      this.genModel.find((fieldRes) => fieldRes.name === 'dateOfLeaving').value = null;
      if (!event.checked) {
        this.form.get('noticePeriod').clearValidators();
        this.form.get('noticePeriod').updateValueAndValidity();
        this.form.get('dateOfLeaving').setValidators(Validators.required);
        this.form.get('dateOfLeaving').updateValueAndValidity();
        this.form.get('dateOfLeaving').enable();
      } else {
        this.form.get('noticePeriod').setValidators(Validators.required);
        this.form.get('noticePeriod').updateValueAndValidity();
        this.form.get('dateOfLeaving').clearValidators();
        this.form.get('dateOfLeaving').updateValueAndValidity();
        this.form.get('dateOfLeaving').disable();
        this.form.get('dateOfLeaving').setValue(null);
      }
    }
  }

  //attachment code

  // getAttachName() {
  //   return this.form.get('attachmentBrowse')['fileName'] ? this.form.get('attachmentBrowse')['fileName'] : '';
  // }

  onAttachmentSelected(event) {
    this.fileAttachArray = [];
    const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    if (files.length === 0) {
      return;
    }

    if (!this.validateAttachment(files[0])) {
      return;
    } else {
      this.fileSizeError = null;
      this.onFileSelected1(files);
    }
  }

  validateAttachment(file: File) {
    // Check file size first
    if (file.size === 0) {
      this.fileSizeError = 'Please upload a non-empty file.';
      return false;
    }

    // Check if form and attachmentType exist
    const attachmentTypeControl = this.form?.get('attachmentType');
    const attachmentType = attachmentTypeControl?.value;

    if (attachmentType && attachmentType.toLowerCase() == 'others') {
      if (file.size > 5242880) {
        this.fileSizeError = 'Please upload maximum 5MB size only.';
        return false;
      }
      return true;
    } else if (attachmentType && attachmentType.toLowerCase() == 'photo') {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (file.size > 2097152 && (fileType == 'png' || fileType == 'jpg' || fileType == 'jpeg')) {
        this.fileSizeError = 'Please upload maximum 2MB size only.';
        return false;
      } else if (fileType != 'png' && fileType != 'jpg' && fileType != 'jpeg') {
        this.fileSizeError = 'Please upload the correct format png|jpg|jpeg';
        return false;
      }
      return true;
    } else if (attachmentType && attachmentType.toLowerCase() == 'resume') {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (file.size > 2097152 && (fileType == 'doc' || fileType == 'docx' || fileType == 'pdf')) {
        this.fileSizeError = 'Please upload maximum 2MB size only.';
        return false;
      } else if (fileType != 'doc' && fileType != 'docx' && fileType != 'pdf') {
        this.fileSizeError = 'Please upload the correct format doc|docx|pdf';
        return false;
      }
      return true;
    } else {
      // Default validation when attachmentType is not set
      const fileType = file.name.split('.').pop().toLowerCase();
      const supportedFormats = ['doc', 'docx', 'pdf', 'xlsx', 'xls', 'png', 'jpg', 'jpeg', 'msg'];

      // Check size limitations based on file type
      if (file.size > 5242880 && (fileType == 'xlsx' || fileType == 'xls')) {
        this.fileSizeError = 'Please upload maximum 5MB size only.';
        return false;
      } else if (
        file.size > 2097152 &&
        (fileType == 'doc' ||
          fileType == 'docx' ||
          fileType == 'pdf' ||
          fileType == 'png' ||
          fileType == 'jpg' ||
          fileType == 'jpeg' ||
          fileType == 'msg')
      ) {
        this.fileSizeError = 'Please upload maximum 2MB size only.';
        return false;
      } else if (!supportedFormats.includes(fileType)) {
        this.fileSizeError = 'Please upload the correct format';
        return false;
      }
      return true;
    }
  }

  onFileSelected1(filesArray) {
    const files = filesArray;
    this.filename = [];
    this.fileMergeAttach = [];
    const lastChunksize = 0;
    const chunkSize = 524288; //maximum 512 = 524,288, 256 = 262,144 B
    this.lastindex = files.length;
    this.key = 1;

    for (const file of files) {
      this.filename.push(file.name);
      this.readFileAttach(file, lastChunksize, this.myCallbackAttach.bind(this), chunkSize);
    }
    const _fileMerge = this.fileMergeAttach;
    const _deletedFile = this.deletedFile;
  }

  readFileAttach(file, lastChunksize: number, callback, chunkSize) {
    const fileBlob = file.slice(lastChunksize, lastChunksize + chunkSize);
    if (fileBlob.size != 0) {
      const fileReader = new FileReader();
      fileReader.onloadend = (_result) => {
        this.fileMergeAttach.push(file);
        return callback(file, lastChunksize, fileReader.result, chunkSize);
      };
      fileReader.readAsText(fileBlob);
    } else {
      return callback(file, lastChunksize, false);
    }
  }

  myCallbackAttach(file, lastChunksize, result, chunkSize) {
    lastChunksize = lastChunksize + chunkSize;
    if (result) {
      this.readFileAttach(file, lastChunksize, this.myCallbackAttach.bind(this), chunkSize);
    } else {
      ///end recursion
      console.log(this.fileMergeAttach);
      this.form.get('attachmentBrowse')['fileName'] = this.fileMergeAttach[0].name;
      this.form.get('attachmentBrowse').setValue(this.fileMergeAttach[0].name);
      this.fileAttachArray.push({
        attachmentId: this.form.get('attachmentType')['attachmentId'],
        fileData: this.fileMergeAttach[0],
      });
      console.log(this.fileAttachArray);
    }
  }

  public downLoadFileData(url) {
    this.http.get<any>(url).subscribe(async res => {
      if (!res) { return; }

      this.attachmentData = res;

      // Build output filename, preserving resume naming convention
      const fileType = this.fileDownloadService.normalizeFileType(res.fileType);
      let fileName: string;
      if (this.form.get('attachmentType').value === 'resume') {
        fileName = this.candidateDetails.candidateId + '_' + (this.candidateDetails.candidateName).replaceAll(' ', '');
      } else {
        fileName = res.fileName || 'download';
      }
      const outputFileName = fileName.endsWith(fileType) ? fileName : fileName + fileType;

      try {
        await this.fileDownloadService.downloadFileFromResponse(res, outputFileName);
      } catch (error) {
        console.error('File download error:', error);
      }
    });
  }

  base64ToArrayBuffer(data) {
    const binaryString = window.atob(data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  setPhoneValidations(value, countryCode, fieldName) {
    const phoneNo = this.genModel.filter((res) => res.name == fieldName);
    const phoneNoMinValidation = phoneNo[0].validations.filter((fill) => fill.name == 'minlength');
    const phoneNoMaxValidation = phoneNo[0].validations.filter((fill) => fill.name == 'maxlength');
    
    console.log(value, countryCode, phoneNoMinValidation, phoneNoMaxValidation);
    if (value == 91) {
      console.log('inside India validation');
      phoneNoMinValidation[0].value = '10';
      phoneNoMinValidation[0].message = 'Minimum length is 10 characters';
      phoneNoMaxValidation[0].value = '10';
      phoneNoMaxValidation[0].message = 'Maximum length is 10 characters';
      this.form.get(fieldName).setValidators(this.bindValidations(phoneNo[0].validations));
      this.form.get(fieldName).updateValueAndValidity({ emitEvent: false });
    } else if (phoneNoMinValidation[0].value !== '7') {
      console.log('inside 7 setting');
      phoneNoMinValidation[0].value = '7';
      phoneNoMinValidation[0].message = 'Minimum length is 7 characters';
      phoneNoMaxValidation[0].value = '15';
      phoneNoMaxValidation[0].message = 'Maximum length is 15 characters';
      this.form.get(fieldName).setValidators(this.bindValidations(phoneNo[0].validations));
      this.form.get(fieldName).updateValueAndValidity({ emitEvent: false });
    }

    // Setup phone validations only once to prevent infinite loops
    if (!this.phoneValidationsSetup) {
      this.phoneValidationsSetup = true;

      // Monitor alternateContactNo changes
      this.form.get('alternateContactNo')?.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe((value) => {
          this.updateCountryCodeValidation('country_code2', value);
        });

      // Monitor emergencyContactNo changes
      this.form.get('emergencyContactNo')?.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe((value) => {
          this.updateCountryCodeValidation('country_code3', value);
        });
    }
  }

  // Helper method to update country code validation
  private updateCountryCodeValidation(countryCodeField: string, phoneValue: any) {
    const countryCodeControl = this.form.get(countryCodeField);
    const validationObj = countryCodeField === 'country_code2' ? this.countryCode2 : this.countryCode3;
    const requiredFlag = countryCodeField === 'country_code2' ? 'countryCode2Required' : 'countryCode3Required';

    if (phoneValue) {
      // Phone has value - add required + pattern validators
      this[requiredFlag] = true;
      countryCodeControl.setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{1,5}$')
      ]);
      validationObj.validations = [
        {
          name: 'required',
          value: 'required',
          message: 'Required',
        },
        {
          name: 'pattern',
          value: '^[0-9]{1,5}$',
          message: 'Invalid',
        },
      ];
    } else {
        // Phone is empty - keep pattern validator always, remove required
        this[requiredFlag] = false;
        countryCodeControl.setValidators([
          Validators.pattern('^[0-9]{1,5}$')
        ]);
        validationObj.validations = [
          {
            name: 'pattern',
            value: '^[0-9]{1,5}$',
            message: 'Invalid',
          },
        ];
      }
    countryCodeControl.updateValueAndValidity({ emitEvent: false });
    countryCodeControl.markAsTouched();
  }
}
